// Collection membership remains enforced by Liquid even without JavaScript.
(() => {
  if (!['pcbstudios.net', 'www.pcbstudios.net'].includes(location.hostname)) return;
  const catalog = `${window.Shopify?.routes?.root || '/'}collections/faf`;
  const isCollection = (path) => /\/collections(?:\/|$)/.test(path) && !path.includes('/products/');
  if (isCollection(location.pathname) && !location.pathname.endsWith('/collections/faf')) {
    const target = new URL(location.href);
    target.pathname = catalog;
    target.searchParams.delete('page');
    target.hash = '';
    location.replace(target.href);
    return;
  }
  const normalize = (root) => {
    for (const link of root.querySelectorAll('a[href]')) {
      const url = new URL(link.getAttribute('href'), location.href);
      if (![location.hostname, 'pcb-studios.com', 'www.pcb-studios.com', 'pcbstudios.net', 'www.pcbstudios.net'].includes(url.hostname)) continue;
      if (!isCollection(url.pathname)) continue;
      url.host = location.host;
      if (!url.pathname.endsWith('/collections/faf')) {
        url.pathname = catalog;
        url.search = '';
      }
      link.href = url.href;
    }
  };
  normalize(document);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) normalize(event.target);
  });
  // Cover links inserted by menu hydration without a whole-document observer.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link?.parentElement) normalize(link.parentElement);
  }, true);
})();
